import MicroModal from "micromodal";
import makeRequest from './make-request'

class Product {
    constructor(id, img, name, price, oldprice, quantity, variations) {
        this.id = id;
        this.img = img;
        this.name = name;
        this.price = price;
        this.oldprice = oldprice;
        this.quantity = quantity;
        this.variations = variations;
    }
}

function formatRubles(value) {
    const number = Number(value);
    return new Intl.NumberFormat('ru-RU', {
        maximumFractionDigits: 0
    }).format(number);
}

function animationBtnCard(btn) {
    btn.classList.add("animation");
    setTimeout(() => {
        btn.classList.remove("animation");
    }, 1000);

}

function getCartArray() {
    return JSON.parse(localStorage.getItem('cart')) || [];
}

function setCartArray(arrayProduct) {
    return localStorage.setItem('cart', JSON.stringify(arrayProduct));
}

function updateProductCounters() {
    const cartArray = getCartArray();

    document.querySelectorAll(".single-counter").forEach(singleCounter => {
        const id = singleCounter.dataset.id;
        const quantityContainer = singleCounter.querySelector(".counter-quantity h4");
        if (!id || !quantityContainer) return;

        const variations = variationsChar();

        const hasVariations = Object.keys(variations).length > 0;
        if (hasVariations) return;
        const product = findProductInCart(cartArray, id, {});
        quantityContainer.textContent = product ? product.quantity : 1;
    });
}


function isEqualVariations(a = {}, b = {}) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(key => b[key] === a[key]);
}

function findProductInCart(cartArray, id, variations = {}) {
    return cartArray.find(p => {
        const sameId = p.id === id;
        const sameVariations = isEqualVariations(p.variations, variations);
        return sameId && sameVariations;
    });
}

function variationsChar() {
    const char = document.querySelector(".characteristics");
    const variations = {};

    if (char) {
        const boxes = char.querySelectorAll(".characteristics-box");

        boxes.forEach((box) => {
            const titleEl = box.querySelector(".characteristics-title");
            const nameEl = box.querySelector(".characteristics-name p");
            const items = box.querySelectorAll(".characteristics-item p");

            const title = titleEl.textContent.trim();

            const defaultValue = nameEl?.textContent?.trim();
            if (defaultValue) {
                variations[title] = defaultValue;
            }

            items.forEach((item) => {
                item.addEventListener("click", () => {
                    const value = item.textContent.trim();
                    nameEl.textContent = value;
                    variations[title] = value;
                });
            });
        });
    }

    return variations;
}


function productCounter() {
    const counters = document.querySelectorAll(".single-counter");

    counters.forEach(singleCounter => {
        const id = singleCounter.dataset.id;
        const variations = variationsChar();

        const quantityContainer = singleCounter.querySelector(".counter-quantity h4");
        const plus = singleCounter.querySelector(".counter-plus");
        const minus = singleCounter.querySelector(".counter-minus");

        if (!id || !quantityContainer || !plus || !minus) return;

        const productArray = getCartArray();

        const product = findProductInCart(productArray, id, variations);
        const hasVariations = Object.keys(variations).length > 0;

        if (hasVariations) {
            quantityContainer.textContent = 1;
        } else {
            quantityContainer.textContent = product ? product.quantity : 1;
        }

        singleCounter.addEventListener('click', (event) => {
            const target = event.target.closest('div');
            if (!target) return;

            let cartArray = getCartArray();

            const product = findProductInCart(cartArray, id, variations);
            let localQuantity

            if (hasVariations) {
                localQuantity = parseInt(singleCounter.dataset.localQuantity, 10) || 1;
            } else {
                localQuantity = product ? product.quantity : parseInt(singleCounter.dataset.localQuantity, 10) || 1;
            }

            if (target === plus) {
                localQuantity += 1;
            } else if (target === minus && localQuantity > 1) {
                localQuantity -= 1;
            } else {
                return;
            }

            quantityContainer.textContent = localQuantity;

            if (product && !hasVariations) {
                product.quantity = localQuantity;
                setCartArray(cartArray);
                refreshCart(document.querySelector(".cart"), document.querySelector("#modal-cart"), cartArray);
                updateProductCounters();
            } else if (hasVariations || !product) {
                singleCounter.dataset.localQuantity = localQuantity;
            }
        });
    });
}

function updateCart(cart, modalCart, productArray) {
    const number = cart.querySelector(".cart-number span");

    const block = modalCart.querySelector(".cart-block");
    const empty = modalCart.querySelector(".cart-empty");

    const count = productArray.length;

    if (count !== 0) {
        block.classList.add("active");
        cart.classList.add("active");
        empty.style.display = 'none';

        number.textContent = count;
    } else {
        block.classList.remove("active");
        cart.classList.remove("active");
        empty.style.display = 'flex';
    }
}

function updateCartList(modalCart) {
    const form = modalCart.querySelector("form");
    const list = modalCart.querySelector(".cart-list");
    const products = getCartArray();


    if (!list) return;

    list.innerHTML = '';

    if (form) {
        form.querySelectorAll('.cart-product-input').forEach(input => input.remove());
        products.forEach((product, index) => {
            const inputName = document.createElement('input');
            inputName.type = 'hidden';
            inputName.name = `products[${product.id}][${index}][name]`;
            inputName.value = product.name;
            inputName.classList.add('cart-product-input');
            form.appendChild(inputName);

            const inputQuantity = document.createElement('input');
            inputQuantity.type = 'hidden';
            inputQuantity.name = `products[${product.id}][${index}][quantity]`;
            inputQuantity.value = product.quantity;
            inputQuantity.classList.add('cart-product-input');
            form.appendChild(inputQuantity);

            if (typeof product.variations === 'object') {
                for (const key in product.variations) {
                    if (product.variations.hasOwnProperty(key)) {
                        const inputVariation = document.createElement('input');
                        inputVariation.type = 'hidden';
                        inputVariation.name = `products[${product.id}][${index}][variations][${key}]`;
                        inputVariation.value = product.variations[key];
                        inputVariation.classList.add('cart-product-input');
                        form.appendChild(inputVariation);
                    }
                }
            }
        });
    }

    products.forEach(product => {
        const item = document.createElement('div');
        item.className = 'cart-item modal-cart__item';
        item.dataset.id = product.id;
        let oldPrice = product.oldprice ? `<p>${formatRubles(product.oldprice)} ₽</p>` : '';
        const variationsParse = product.variations && typeof product.variations === 'object'
            ? Object.entries(product.variations).map(([key, value]) => `${key}: ${value}`).join("; ")
            : '';
        const dataVariations = product.variations
            ? JSON.stringify(product.variations).replace(/"/g, '&quot;')
            : '';
        const variationsString = `<span class="font">${variationsParse ? variationsParse + ';' : ''}</span>`;
        item.innerHTML = `
        <div class="modal-cart__item-left">
            <img class="modal-cart__item-img" src="${product.img}" alt="${product.name}">
            <div class="modal-cart__item-char">
                <p class="modal-cart__item-name">${product.name}</p>
                ${variationsString}
            </div>
        </div>
        <div class="modal-cart__item-right">
                <div class="modal-cart__item-price modal-cart__item-price-mob">
                    <h3>${formatRubles(product.price)} ₽</h3>
                    ${oldPrice}
                </div>
            <div class="modal-cart__item-counter">
                <span class="item-minus modal-cart__item-counter-minus" data-id="${product.id}" data-variations="${dataVariations}">-</span>
                <div class="item-quantity modal-cart__item-quantity">${product.quantity}</div>
                <span class="item-plus modal-cart__item-counter-plus" data-id="${product.id}" data-variations="${dataVariations}">+</span>
            </div>
            <div class="modal-cart__item-box">
                <div class="modal-cart__item-price">
                    <h3>${formatRubles(product.price)} ₽</h3>
                    ${oldPrice}
                </div>
                <div class="item-delete modal-cart__item-delete" data-id="${product.id}" data-variations="${dataVariations}">
                    <svg class="icon icon-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8.46 11.88L9.87 10.47L12 12.59L14.12 10.47L15.53 11.88L13.41 14L15.53 16.12L14.12 17.53L12 15.41L9.88 17.53L8.47 16.12L10.59 14L8.46 11.88ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z" fill="#4280EF"/>
                    </svg>
                </div>
            </div>
        </div>
        `;

        list.appendChild(item);
    });

    updateSummary(modalCart);
}

function updateSummary(modalCart) {
    const deliverys = modalCart.querySelectorAll('input[name="radio-address"]');
    const final = modalCart.querySelector(".final-price h3");
    const firstPrice = modalCart.querySelector(".first-price h3");

    const form = modalCart.querySelector("form");
    const products = getCartArray();

    let price = 0;

    products.forEach(product => {
        price += (product.price * product.quantity);
    });

    firstPrice.textContent = `Итого: ${formatRubles(price)} ₽`;

    deliverys.forEach(delivery => {
        if (delivery.checked) {
            let markup = delivery.dataset.price ? parseInt(delivery.dataset.price) : 0;
            price += markup;
        }
    });

    final.textContent = `${formatRubles(price)} ₽`;

    const existingInput = form.querySelector('input[name="price"]');
    if (existingInput) {
        existingInput.remove();
    }

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'price';
    input.value = price;

    form.insertBefore(input, form.firstChild);
}

function attachCartItemEvents(cart, modalCart) {
    modalCart.addEventListener('click', (e) => {
        const target = e.target.closest('[data-id]');
        if (!target) return;

        const id = target.dataset.id;
        const variationsRaw = target.dataset.variations;
        const variations = variationsRaw ? JSON.parse(variationsRaw) : {};
        const cartArray = getCartArray();
        let product = findProductInCart(cartArray, id, variations);

        if (target.classList.contains('item-plus') && product) {
            product.quantity += 1;
            refreshCart(cart, modalCart, cartArray);
            updateProductCounters();
        }

        if (target.classList.contains('item-minus') && product) {
            product.quantity = Math.max(1, product.quantity - 1);
            refreshCart(cart, modalCart, cartArray);
            updateProductCounters();
        }

        if (target.classList.contains('item-delete')) {
            const relatedButton = document.querySelector(`.cart-edit[data-id="${id}"]`);
            const counter = document.querySelector(`.single-counter[data-id="${id}"]`);
            const cartItem = target.closest(".cart-item");

            if (counter) {
                counter.classList.add("disabled");
            }

            if (cartItem) {
                const originHtml = cartItem.innerHTML;
                cartItem.innerHTML = `
                <div class="modal-cart__item-left modal-cart__item-left-delete">
                    <div class="item-timer modal-cart__item-timer">
                        <svg class="modal-cart__item-progressbar" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle
                                class="cart-progressbar-circle"
                                cx="50" cy="50" r="45"
                                stroke="#ff5555"
                                stroke-width="3"
                                fill="none"
                                stroke-dasharray="282.74"
                                stroke-dashoffset="0"
                                style="transform: rotate(-90deg); transform-origin: center;"
                            ></circle>
                        </svg>
                        <span class="h4">5</span>
                    </div>
                    <div class="p modal-cart__item-name">
                        Вы удалили<br>
                        ${product.name}
                    </div>
                </div>
                <div class="modal-cart__item-right modal-cart__item-right-delete">
                    <span class="item-resume h4 modal-cart__item-resume">
                        Возобновить
                    </span>
                </div>
                `;

                const resume = cartItem.querySelector(".item-resume");
                const timer = cartItem.querySelector(".item-timer span");
                const progressPath = cartItem.querySelector(".cart-progressbar-circle");

                const radius = 45;
                const circumference = 2 * Math.PI * radius;
                progressPath.style.strokeDasharray = `${circumference}`;
                progressPath.style.strokeDashoffset = `0`;

                const duration = 5000;
                let startTime;
                let timeoutId;
                let animationFrameId;

                function animate(timestamp) {
                    if (!startTime) startTime = timestamp;
                    const elapsed = timestamp - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const offset = circumference * progress;

                    progressPath.style.strokeDashoffset = -offset;
                    const secondsLeft = Math.ceil((duration - elapsed) / 1000);
                    timer.textContent = secondsLeft;

                    if (progress < 1) {
                        animationFrameId = requestAnimationFrame(animate);
                    } else {
                        timer.textContent = "0";
                    }
                }

                animationFrameId = requestAnimationFrame(animate);

                resume.addEventListener("click", () => {
                    if (counter) {
                        counter.classList.remove("disabled");
                    }
                    clearTimeout(timeoutId);
                    cancelAnimationFrame(animationFrameId);
                    cartItem.innerHTML = originHtml;
                });

                timeoutId = setTimeout(() => {
                    let cartArray = getCartArray().filter(p => !(p.id === id && isEqualVariations(p.variations, variations)));
                    setCartArray(cartArray);

                    if (counter) {
                        counter.classList.remove("disabled");
                        counter.dataset.localQuantity = 1;
                        const quantityContainer = counter.querySelector(".counter-quantity h4");
                        if (quantityContainer) quantityContainer.textContent = 1;
                    }

                    if (relatedButton) relatedButton.classList.remove("active");

                    cartItem.remove();
                    updateSummary(modalCart);

                    const remainingItems = modalCart.querySelectorAll(".cart-item");
                    if (remainingItems.length === 0) {
                        refreshCart(cart, modalCart, cartArray);
                    }

                    updateProductCounters();
                }, duration);
            }
        }
    });

    modalCart.querySelectorAll('input[name="radio-address"]').forEach(address => {
        address.addEventListener('change', () => {
            refreshCart(cart, modalCart, getCartArray());
        });
    });
}

function refreshCart(cart, modalCart, productArray) {
    setCartArray(productArray);
    updateCart(cart, modalCart, productArray);
    if (productArray.length != 0) {
        updateCartList(modalCart);
        updateSummary(modalCart);
    } else {
        const form = modalCart.querySelector("form");
        const list = modalCart.querySelector(".cart-list");

        if (list) list.innerHTML = "";
        if (form) {
            form.reset();
            const inputs = form.querySelectorAll("input");
            inputs.forEach((input) => {
                const label = input.closest("label");
                if (label) label.classList.remove("active");
            })
        }

    }
}

function cartResulte(buttons, response, status, selectedValue) {
    const cart = document.querySelector(".cart");
    const modalCart = document.querySelector("#modal-cart");
    const form = modalCart.querySelector("form");

    if (status >= 200 && status < 300) {

        if (buttons) {
            buttons.forEach((btn) => {
                btn.classList.remove("active");
            });
        }

        setCartArray([]);
        refreshCart(cart, modalCart, []);

        document.activeElement.blur();
        MicroModal.close('modal-cart');

        setTimeout(async () => {
            if (selectedValue === 'online') {
                const formData = new FormData(form);
                formData.append('action', 'donate');

                const result = await makeRequest(window.ajaxUrl, formData, 'POST');

                if (result.status === 'success' && result.pay_link) {
                    window.location.href = result.pay_link;
                } else {
                    MicroModal.show('cart-online-fail');
                }

            } else {
                MicroModal.show('cart-cash-success');
            }
        }, 300);
    } else {
        console.warn('Ошибка при отправке:', response);

        if (selectedValue === 'online') {
            MicroModal.show('cart-online-fail');
        } else {
            MicroModal.show('cart-cash-fail');
        }
    }
}


document.addEventListener("DOMContentLoaded", () => {
    const cart = document.querySelector(".cart");
    if (cart) {
        const modalCart = document.querySelector("#modal-cart");
        const buttons = document.querySelectorAll(".cart-edit");

        let productArray = getCartArray();

        updateCart(cart, modalCart, productArray);
        updateCartList(modalCart);
        attachCartItemEvents(cart, modalCart);

        variationsChar();
        productCounter();

        buttons.forEach((btn) => {
            const id = btn.getAttribute("data-id");
            const img = btn.getAttribute("data-img") || '';
            const name = btn.getAttribute("data-name");
            const price = btn.getAttribute("data-price");
            const oldPrice = btn.getAttribute("data-oldprice");

            const variationsRaw = btn.dataset.variations;
            const variations = variationsRaw ? JSON.parse(variationsRaw) : {};
            const currentVariations = variationsChar();

            const existingProductById = productArray.find(p => p.id === id);
            const existingProductByVariations = productArray.find(p => isEqualVariations(p.variations, currentVariations));

            const hasVariations = Object.keys(currentVariations).length > 0;
            if (!hasVariations && existingProductById && Object.keys(existingProductById.variations).length === 0) {
                btn.classList.add("active");
            } else if (hasVariations) {
                btn.classList.add("anim");
            }

            btn.addEventListener("click", () => {
                const counter = document.querySelector(`.single-counter[data-id="${id}"]`);
                const quantityContainer = counter?.querySelector(".counter-quantity h4");
                const num = quantityContainer ? parseInt(quantityContainer.textContent, 10) : 1;

                let productArray = getCartArray();

                const valideProduct = findProductInCart(productArray, id, currentVariations);
                if (valideProduct) {
                    valideProduct.quantity += num;
                } else {
                    const product = new Product(id, img, name, price, oldPrice, num, currentVariations);
                    productArray.push(product);
                }

                if (Object.keys(currentVariations).length === 0) {
                    btn.classList.add("active");
                } else {
                    animationBtnCard(btn);
                }

                refreshCart(cart, modalCart, productArray);
            });
        });


        document.body.addEventListener('htmx:afterRequest', (event) => {
            const modalCart = document.querySelector('#modal-cart');
            if (!modalCart.contains(event.target)) return;
            const xhr = event.detail.xhr;
            const selectedRadio = document.querySelector('input[name="radio-payment"]:checked');
            const selectedValue = selectedRadio ? selectedRadio.value : null;

            cartResulte(buttons, xhr.responseText, xhr.status, selectedValue);
        });

    }
})